
export const EMPLOYEE_MODE_SOURCE = {
    DASHBOARD: "fromDashboard",
    SETTINGS: "fromSettings",
    USER_LIST: "fromUserList",
};

export const getPreviewUrl = (file) => {
    if (!file) return null;

    if (file.url) return file.url;

    if (file instanceof File) {
        return URL.createObjectURL(file);
    }

    return null;
};
